import React, { useState } from "react";
import SMSelect from "../../elements/select/SMSelect";
import HistoryScoinBox from "./components/HistoryScoinBox";
import HistoryScoinTable from "./components/HistoryScoinTable";

const HistoryScoin = () => {
  const [selectedType, setselectedType] = useState("grid");
  let type = [
    { value: "table", label: "table" },
    { value: "grid", label: "grid" },
  ];
  return (
    <div
      className="w-full flex flex-col p-10 dark:text-white"
      style={{ minHeight: "100vh" }}
    >
      <div className="block mb-8">
        <div className="flex">
          <h1 className="text-3xl font-bold mr-4">History Scoin</h1>
          <div className="flex w-40">
            <SMSelect
              data={type}
              defaultValue={type[1]}
              onChange={(e) => setselectedType(e.value)}
            />
          </div>
        </div>
      </div>

      {selectedType !== "grid" ? (
        <div>
          <HistoryScoinTable />
        </div>
      ) : (
        <div className="grid grid-flow-row grid-cols-2 gap-4">
          <HistoryScoinBox />
          <HistoryScoinBox />
          <HistoryScoinBox />
        </div>
      )}
    </div>
  );
};

export default HistoryScoin;
